module.exports = __webpack_public_path__ + "static/media/smiley.47f3e2be.svg";